"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainbridgeConfig = void 0;
exports.chainbridgeConfig = window.__RUNTIME_CONFIG__.CHAINBRIDGE;
//# sourceMappingURL=chainbridgeConfig.js.map